import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectIsAuthReady } from 'services/login/slice';
import { Permission } from 'utils/permissions';

export const useAuth = () => {
  const isAuthReady = useSelector(selectIsAuthReady);
  const user = useSelector(selectCurrentUser);

  return useMemo(() => ({ isAuthReady, user }), [isAuthReady, user]);
};

export const useHasPermission = (permission: Permission) => {
  const { user } = useAuth();
  return Boolean(user?.permissions?.includes(permission));
};
